export default function ValueToColorHelper(value) {
	if (value >= 90) {
		return '#1ABE10';
	} else if (value >= 80) {
		return '#4BC818';
	} else if (value >= 70) {
		return '#7DD220';
	} else if (value >= 60) {
		return '#AFDC28';
	} else if (value >= 50) {
		return '#E1E630';
	} else if (value >= 40) {
		return '#EDCC2E';
	} else if (value >= 30) {
		return '#E9A227';
	} else if (value >= 20) {
		return '#E57820';
	} else if (value >= 10) {
		return '#E04E1A';
	} else {
		return '#DC2413';
	}
}
